import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import { getEventsRoute, getGoStarRoute, getNetworkRoute } from "../../../../routers/routeUtils";

import ActionCardBGImg from "../../assets/images/action-card-bg.png";
import { ActionCardIcon, ActionCardArrowRightIcon } from "../../assets/icons/gino-icons";

export const GinoHomeQuickActionsSection = () => {
  const { t, i18n } = useTranslation("gino", { keyPrefix: "homePage" });

  const navigate = useNavigate();
  const actions = [
    {
      title: t("compareTalentsAndProfessionals"),
      actionTitle: t("compareNow"),
      actionHandler: () => navigate(getGoStarRoute()),
    },
    {
      title: t("arrangeAFootballEvent"),
      actionTitle: t("createEvent"),
      actionHandler: () => navigate(getEventsRoute()),
    },
    {
      title: t("buildFootballNetwork"),
      actionTitle: t("buildNow"),
      actionHandler: () => navigate(getNetworkRoute("followers")),
    },
  ];
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("quickActions")}</Typography>
      <Box sx={styles.actionsContainer}>
        {actions.map(({ title, actionTitle, actionHandler }, index) => (
          <Box key={index} sx={styles.actionCardContainer}>
            <Box sx={styles.actionCardIconContainer}>
              <ActionCardIcon />
            </Box>
            <Typography sx={styles.actionTitle}>{title}</Typography>
            <Button
              variant="text-md"
              onClick={actionHandler}
              sx={styles.actionButton}
              endIcon={<ActionCardArrowRightIcon />}
            >
              {actionTitle}
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  title: {
    color: "var(--text-base-primary, #14151A)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "var(--typography-line-height-h6, 32px)",
  },
  actionsContainer: {
    display: "grid",
    gridTemplateColumns: { xs: "repeat(1, 1fr)", md: "repeat(3, 1fr)" },
    columnGap: "6px",
    rowGap: "16px",
  },
  actionCardContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "16px",
    borderRadius: "12px",
    border: "1px solid var(--Color-Gray-200, #E4E7EB)",
    background: `url(${ActionCardBGImg}) no-repeat right center`,
    backgroundSize: "cover",
    boxShadow: "0 1px 2px 0 rgba(20, 21, 26, 0.05)",
  },
  actionCardIconContainer: {
    width: "48px",
    height: "48px",
    borderRadius: "24px",
    background: "var(--Brand-100, #C9FFC4)",
    padding: "12px",
  },
  actionTitle: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "140%",
    maxWidth: "80%",
  },
  actionButton: {
    padding: "0",
    background: "transparent !important",
    width: "fit-content",
    mt: "auto",
  },
};
